export default __webpack_public_path__ + "static/media/uploader-tandem-3.15eee3d2.png";